"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestBeforeHook = void 0;
function requestBeforeHook({ requestBody, queryParameters, path, requestConfig, configuration, pathTemplate, httpMethod }) { }
exports.requestBeforeHook = requestBeforeHook;
